import template from "./bShareModal.html";
import moment from "moment";
import { entryToName } from "./chartNaming";

export function bShareModalDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bShareModalController,
    controllerAs: 'bShareModal',
    bindToController: true,
    scope: {
      selectedClient: "=",
      showModal: "="
    },
  };

  return directive;
}

class bShareModalController {
  constructor(API, Clients, Notes, bModal, $translate, $scope, $interval) {
    'ngInject';

    this.Notes = Notes;
    this.bModal = bModal;
    this.API = API;
    this.Clients = Clients;
    this.$translate = $translate;
    this.$scope = $scope;
    this.$interval = $interval;
    this.expiresAt = "";
    this.sharedClients = [];
    this.entryToName = entryToName;

    this.shareHeaders = [
      {name: this.$translate.instant("VIEW360.MODAL.SHARES"), class: "table-info-long", sort:"shares"},
      {name: this.$translate.instant("VIEW360.MODAL.CREATED"), class: "table-date", sort:"created"},
      {name: this.$translate.instant("VIEW360.MODAL.EXPIRES"), class: "table-date", sort:"validFrom"},
      {name: this.$translate.instant("VIEW360.MODAL.VIEWS"), class: "table-date", sort:"validUntil"},
      {name: this.$translate.instant("VIEW360.MODAL.STATUS"), class: "table-short"},
      {id: "actions", name: null, class: "table-actions"},
    ];
    this.state = "loading";
    this.init();
  }

  init() {

    var timeout = this.$interval(() => {
      this.notes = this.Notes.getNotes();
    }, 10);
    this.$scope.$on("$destroy", () => {this.$interval.cancel(timeout);});

    this.state = "loading";
    this.Clients.getShared360ManagementData().then(res => {
      const Shares = res.data.map((x)=>{
        return {
          ...x,
          nameToShow: this.entryToName(x),
          status: x.status === "Active",
          isEdited: false,
          oldName: x.shareName,
          oldDate: x.expiresAt
        };
      }).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      this.sharedClients = Shares;
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  getLink(id){
    return `${this.API.shareUrl}/stats/management/360-view/shared/${id}`;
  }

  closeShareModal(){
    this.showModal = false;
  }

  isActive(status){
    return status;
  }

  shareDateFormat(time){
    return moment(time).format("DD/MM/YYYY");
  }

  shareDateFormatMM(createdAt){
    return moment(createdAt).format("MMM YYYY");
  }

  changeDate(id, date, createdAt, shareObject) {
    let transformedDate = moment(date, 'DD/MM/YYYY').toISOString();
    let created = moment(createdAt).toISOString();

    if (moment(transformedDate).isSameOrBefore(created)) {
      this.Notes.postNote({
        type: "error",
          message: this.$translate.instant("VIEW360.MODAL.ERROR_DATE")
      });
    } else {
      date = moment(date, 'DD/MM/YYYY').add(1, 'day').subtract(1,"millisecond");
      date = date.toISOString();
      shareObject.expiresAt = date;
    }
  }

  restoreShare(id){
    const added7Days  = moment().startOf('day').add(8, 'days').subtract(1,"millisecond").toISOString();
    this.Clients.patchExpire(id, added7Days).then(() => {
      this.Notes.postNote({
        type: "success",
        message: this.$translate.instant("VIEW360.MODAL.SUCCESS_RESTORED")
      });
      this.init();
    }, (res) => {
      this.Notes.postNote({
        type: "error",
        message: res.data
      });
    });
  }

  showName(share){
    if(!share.shareName){
      return entryToName(share);
    }
    return share.shareName;
  }

  editShare(share){
    share.isEdited = true;
  }

  saveShare(share){
    const data = {
      shareName: share.shareName,
      expiresAt: share.expiresAt
    };
    this.Clients.saveShare(share.id, data).then(() => {
      this.Notes.postNote({
        type: "success",
        message: this.$translate.instant("VIEW360.MODAL.SUCCESS_SAVED")
      });
      share.isEdited = false;
    }, (res) => {
      this.Notes.postNote({
        type: "error",
        message: res.data
      });
    });

  }

  deleteShare(share){
    this.modalConfig = {
      text: this.$translate.instant("VIEW360.MODAL.QUESTION_DELETE"),
      cancelText: this.$translate.instant("VIEW360.MODAL.NO"),
      acceptText: this.$translate.instant("VIEW360.MODAL.YES")
    };

    this.bModal.show(this.modalConfig).then(() => {
      this.Clients.deleteShare(share.id).then(() => {
        this.Notes.postNote({
          type: "success",
          message: this.$translate.instant("VIEW360.MODAL.SUCCESS_DELETED")
        });
        this.sharedClients = this.sharedClients.filter(shareItem => shareItem.id !== share.id);
      }, (res) => {
        this.Notes.postNote({
          type: "error",
          message: res.data
        });
      });
    }, angular.noop);
  }

  editCancel(share){
    share.shareName = share.oldName;
    share.expiresAt = share.oldDate;
    share.isEdited = false;
  }


  expireShare(id){
    this.modalConfig = {
      text: this.$translate.instant("VIEW360.MODAL.QUESTION"),
      cancelText: this.$translate.instant("VIEW360.MODAL.NO"),
      acceptText: this.$translate.instant("VIEW360.MODAL.YES")
    };

    this.bModal.show(this.modalConfig).then(() => {
      this.Clients.expireShare(id).then(() => {
        this.Notes.postNote({
          type: "success",
          message: this.$translate.instant("VIEW360.MODAL.SUCCESS_EXPIRED")
        });
        this.init();
      }, (res) => {
        this.Notes.postNote({
          type: "error",
          message: res.data
        });
      });
    }, angular.noop);

  }
}
